const SUBMIT_CAPTCHA = "captcha_validator/SUBMIT_CAPTCHA";
const SUBMIT_CAPTCHA_SUCCESS = "captcha_validator/SUBMIT_CAPTCHA_SUCCESS";
const SUBMIT_CAPTCHA_FAIL = "captcha_validator/SUBMIT_CAPTCHA_FAIL";


const initialState = {
  pending: true,
  loaded: false,
  captcha_validator: {},
  error: null
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SUBMIT_CAPTCHA:
      return Object.assign({}, state, {
        pending: true,
        loaded: false
      });
    case SUBMIT_CAPTCHA_SUCCESS:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        captcha_validator: { ...action.results },
        error: null
      });
    case SUBMIT_CAPTCHA_FAIL:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        error: action.error
      });

    default:
      return state;
  }
}

export function submitCaptchaPending() {
  return {
    type: SUBMIT_CAPTCHA
  };
}

export function submitCaptchaSuccess(results) {
  return {
    type: SUBMIT_CAPTCHA_SUCCESS,
    results
  };
}

export function submitCaptchaFail(error) {
  return {
    type: SUBMIT_CAPTCHA_FAIL,
    error
  };
}

export const submitCaptchaValidator = state => state.captcha_validator;
export const getError = state => state.error;
export const getPending = state => state.pending;
export const getLoaded = state => state.loaded;
